import React from 'react';
import styled from 'styled-components';
import { AiAssistantProvider } from './AiAssistantContext';
import Layout from './components/Layout';

const AiAssistant: React.FC = () => {
  return (
    <AiAssistantProvider>
      <Container>
        <Layout />
      </Container>
    </AiAssistantProvider>
  );
};

export default AiAssistant;

const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
`;
